// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lx-1";
export var stateContainer = "_lx-0";